var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48792 0 0 4.48792 0 10C0 15.5121 4.48792 20 10 20C15.5121 20 20 15.5121 20 10C20 4.48792 15.5121 0 10 0ZM10 1.81818C14.5295 1.81818 18.1818 5.47054 18.1818 10C18.1818 14.5295 14.5295 18.1818 10 18.1818C5.47054 18.1818 1.81818 14.5295 1.81818 10C1.81818 5.47054 5.47054 1.81818 10 1.81818ZM9.09091 4.54545V5.625C8.04024 6.00521 7.27273 7.00728 7.27273 8.18182C7.27273 9.67725 8.50457 10.9091 10 10.9091C10.5137 10.9091 10.9091 11.3045 10.9091 11.8182C10.9091 12.3318 10.5137 12.7273 10 12.7273C9.48634 12.7273 9.09091 12.3318 9.09091 11.8182H7.27273C7.27273 12.9927 8.04024 13.9948 9.09091 14.375V15.4545H10.9091V14.375C11.9598 13.9948 12.7273 12.9927 12.7273 11.8182C12.7273 10.3228 11.4954 9.09091 10 9.09091C9.48634 9.09091 9.09091 8.69548 9.09091 8.18182C9.09091 7.66815 9.48634 7.27273 10 7.27273C10.5137 7.27273 10.9091 7.66815 10.9091 8.18182H12.7273C12.7273 7.00728 11.9598 6.00521 10.9091 5.625V4.54545H9.09091Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/DollarIcon.1810ef42b6227de41c8f81b1a63e53bb.svg";
export { ForwardRef as ReactComponent };